module.exports = __webpack_public_path__ + "img/metamask-logo-horizontal.0c760855.svg";